import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { fetchCategories, fetchDayWiseAttendanceReport, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, resetAttendanceReport } from "store/actions";
import Loader from "common/pageLoader";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const AttendanceReportDayWise = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    categories,
    departments,
    dropdownAutoList,
    designations,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.AttendanceReportReducer?.employeeReport ?? [],
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
    designations: state.DesignationMaster?.designations ?? [],

    loading: state.AttendanceReportReducer?.loading,
    error: state.AttendanceReportReducer?.error,
    success: state.AttendanceReportReducer?.success,
  }));

  useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

  useEffect(() => {
    dispatch(resetAttendanceReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId))
    dispatch(fetchDesignations(unitId));
  }, [dispatch]);
  const [source, setSource] = useState("Punch List");

  const formik = useFormik({
    initialValues: {
      department: "",
      designation: "",
      category: "",
      employee: "",
      fromDate: "",
      toDate: ""
    },
    validationSchema: Yup.object({
      fromDate: Yup.date().nullable()
        .required("From Date is required"),

      toDate: Yup.date().nullable()
        .required("To Date is required")
        .min(
          Yup.ref("fromDate"),
          "To Date must be greater than or equal to From Date"
        ),
    }),
    onSubmit: (values) => {
      // console.log("Submitted values:", values);
      const formData = new FormData();
      formData.append("emp_dep", formik.values.department || 0);
      formData.append("emp_design", formik.values.designation || 0);
      formData.append("emp_cat", formik.values.category || 0);
      formData.append("emp_no", formik.values.employee || 0);
      formData.append("from_date", formik.values.fromDate);
      formData.append("to_date", formik.values.toDate);

      formData.append("unit_id", authDetails?.unit_id);
      formData.append("created_by", authDetails?.user_id);

      dispatch(fetchDayWiseAttendanceReport(formData));
    },
  });

  const columns = [
    { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Department", accessor: "department" },
    { Header: "Shift", accessor: "shift_name" },
    { Header: "Date", accessor: "shift_date" },
    { Header: "Punch In", accessor: "in_punch" },
    { Header: "Punch Out", accessor: "out_time" },
    { Header: "Working Hrs", accessor: "working_hours" },
    { Header: "Late Hrs", accessor: "late_hours" },
    { Header: "Early Hrs", accessor: "early_hours" },
    { Header: "Extra Hrs", accessor: "extra_hours" },
    { Header: "On Duty Hrs", accessor: "on_duty_hours" },
    { Header: "Remarks", accessor: "remarks" },
  ];

  const handleReset = () => {
    formik.resetForm();
    dispatch(resetAttendanceReport());
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Day Wise Report" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                {/* <Col md={12}>
                  <Label className="me-2">Source</Label>
                  <div className="d-flex align-items-center gap-2">
                    <Input
                      type="radio"
                      name="source"
                      value="Punch List"
                      checked={source === "Punch List"}
                      onChange={() => setSource("Punch List")}
                    />{" "}
                    Punch List
                    <Input
                      type="radio"
                      name="source"
                      value="Shift Attendance"
                      checked={source === "Shift Attendance"}
                      onChange={() => setSource("Shift Attendance")}
                      className="ms-3"
                    />{" "}
                    Shift Attendance
                  </div>
                </Col>

                {source === "Shift Attendance" && (
                  <Col md={4}>
                    <Label>Shift</Label>
                    <CustomSelect
                      name="shift"
                      value={formik.values.shift}
                      onChange={(val) => formik.setFieldValue("shift", val)}
                      options={shiftOptions}
                      placeholder="--Select--"
                    />
                  </Col>
                )} 
                 
                {source === "Punch List" && (
                  <>
                    <Col md={4}>
                      <Label>
                        From Date
                      </Label>
                      <CustomDatePicker
                        name="fromDate"
                        value={formik.values.fromDate}
                        onChange={(val) => formik.setFieldValue("fromDate", val)}
                        onBlur={formik.handleBlur}
                      />
                    </Col>

                    <Col md={4}>
                      <Label>
                        To Date
                      </Label>
                      <CustomDatePicker
                        name="toDate"
                        value={formik.values.toDate}
                        onChange={(val) => formik.setFieldValue("toDate", val)}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                  </>
                )}

                {source === "Shift Attendance" && (
                  <Col md={4}>
                    <Label>
                      Date
                    </Label>
                    <CustomDatePicker
                      name="date"
                      value={formik.values.date}
                      onChange={(val) => formik.setFieldValue("date", val)}
                      onBlur={formik.handleBlur}
                    />
                  </Col>
                )}

                <Col md={4}>
                  <Label>Code</Label>
                  <Input
                    name="code"
                    value={formik.values.code}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={4}>
                  <Label>Name</Label>
                  <Input
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col> 

                 */}

                <Col md={3}>
                  <Label>Category</Label>
                  <CustomSelect
                    id="category"
                    name="category"
                    options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                    value={
                      categories
                        .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                        .find(cat => cat.value === formik.values.category) || null
                    }
                    onChange={val => formik.setFieldValue('category', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                  />
                </Col>

                <Col md={3}>
                  <Label>Department</Label>
                  <CustomSelect
                    id="department"
                    name="department"
                    options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                    value={
                      departments
                        .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                        .find(dept => dept.value === formik.values.department) || null
                    }
                    onChange={val => formik.setFieldValue('department', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.department && formik.errors.department ? 'is-invalid' : ''}`}
                  />
                </Col>

                <Col md={3}>
                  <Label>Designation</Label>
                  <CustomSelect
                    id="designation"
                    name="designation"
                    options={designations.map(des => ({ value: des.desig_id, label: des.designation }))}
                    value={
                      designations
                        .map(des => ({ value: des.desig_id, label: des.designation }))
                        .find(des => des.value === formik.values.designation) || null
                    }
                    onChange={(val) => formik.setFieldValue("designation", val ? val.value : "")}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.designation && formik.errors.designation ? "is-invalid" : ""
                      }`}
                  />
                </Col>
                <Col md={3}>
                  <Label>
                    Employee
                  </Label>
                  <CustomSelect
                    id="employee"
                    name="employee"
                    options={dropdownAutoList.map(emp => ({
                      value: String(emp.emp_id),
                      label: emp.emp_no
                    }))}

                    // UI needs the object, so find matching option
                    value={
                      dropdownAutoList
                        .map(emp => ({
                          value: String(emp.emp_id),
                          label: emp.emp_no
                        }))
                        .find(option => option.value === formik.values.employee) || null
                    }

                    // Form Data: store string only
                    onChange={(selected) =>
                      formik.setFieldValue("employee", selected ? selected.value : "")
                    }
                  />
                  {formik.touched.employee && formik.errors.employee && (
                    <div className="text-danger">
                      {formik.errors.employee}
                    </div>
                  )}
                </Col>
                <Col md={3}>
                  <Label>From Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate && (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  )}
                </Col>

                <Col md={3}>
                  <Label>To Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.toDate && formik.errors.toDate && (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  )}
                </Col>


                <Col className="d-flex mob-center align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2 mt-2" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-2">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Daywise Attendance Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Daywise Attendance Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={employeeReport}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportDayWise;